<div class="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
    @for (option of filterOptions; track option) {
        <label class="flex items-center space-x-2">
            <input
                type="checkbox"
                [(ngModel)]="option.selected"
                (change)="onFilterChanged()"
            />
            <p class="text-xs !mb-0">{{ option.label }}</p>
        </label>
    }
</div>
